export const FETCH_OT_NONALLOCATED_LOC_REQUEST = "FETCH_OT_NONALLOCATED_LOC_REQUEST";
export const FETCH_OT_NONALLOCATED_LOC_SUCCESS = "FETCH_OT_NONALLOCATED_LOC_SUCCESS";
export const FETCH_OT_NONALLOCATED_LOC_FAILURE = "FETCH_OT_NONALLOCATED_LOC_FAILURE";